import { Input } from '@/components/Input/Input'
import SearchIcon from '@mui/icons-material/Search'
import React from 'react'
import styles from './Search.module.scss'
import { Button, Select } from '@/ui'
import { useTranslation } from 'react-i18next'
import cl from 'classnames'

export const Search = ({
												 handleSearch, handleSelect, handleReset, options = [], values, onInputChange
											 }) => {
	const { t } = useTranslation()


	const {input, select} = values

	return (
		<div className={cl('flex', 'align-items-center', 'gap-3')}>
			<Input
				prefix={<SearchIcon />}
				containerClassName={cl(styles.inputClass, 'flex-2')}
				placeholder={t('nomination.search')}
				onChange={(e) => onInputChange(e.target.value)}
				value={input}
				postfix={(
					<Button type="bare" onClick={() => handleSearch(input)}>
						{t('find')}
					</Button>
				)}
			/>

			<Select
				options={options}
				className={cl('flex-1')}
				value={select}
				onChange={(value) => {
					handleSelect(value)
				}}
			/>

			<Button type="bare" onClick={() => {
				handleReset()
			}}>
				{t('electronic_contract.reset')}
			</Button>
		</div>
	)
}